import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {queryParamsType} from '../../constants/proptype-validation';
import i18n from '../../utils/i18n';
import {TYPE_QUALITY_ISSUES} from '../../constants/issue-types';
import {PAGE_PARAMS, SORTING_PARAMS} from '../../constants/issue-query-params';
import {preloadedSortQueryParamsState} from '../../constants/preloaded-states';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import SelectBoxAdapter from '../common/SelectBoxAdapter';

export default class extends PureComponent {
  static displayName = 'Sort';

  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    setQueryParamsAction: PropTypes.func.isRequired,
    queryParams: queryParamsType.isRequired,
    onLabelClick: PropTypes.func.isRequired,
    displaySortDropdown: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    const rawOptions = [
      {id: 'title', text: i18n.t('sort.titleAscending'), title: i18n.t('sort.title')},
      {id: '-title', text: i18n.t('sort.titleDescending'), title: i18n.t('sort.title')},
      {
        id: 'status',
        text: i18n.t('sort.status'),
        title: i18n.t('sort.status'),
        onlyAscending: true
      },
      {
        id: ISSUE_ATTRIBUTE_NAMES.ID,
        text: i18n.t('sort.identifierAscending'),
        title: i18n.t('sort.identifier')
      },
      {
        id: `-${ISSUE_ATTRIBUTE_NAMES.ID}`,
        text: i18n.t('sort.identifierDescending'),
        title: i18n.t('sort.identifier')
      },
      {id: 'dueDate', text: i18n.t('sort.dueDateAscending'), title: i18n.t('sort.dueDate')},
      {id: '-dueDate', text: i18n.t('sort.dueDateDescending'), title: i18n.t('sort.dueDate')}
    ];

    const sortOptions = rawOptions.map(option => ({
      hideTitle: true,
      value: option.id,
      label: option.text,
      labelDisplayText: `${i18n.t('sort.sortingBy')} ${option.title} ${
        option.onlyAscending ? '' : option.id[0] === '-' ? '\u2193' : '\u2191'
      }`
    }));

    const currentSorting = sortOptions.find(option => option.value === this.props.queryParams[SORTING_PARAMS.SORT]);
    const labelDisplayText =
      !currentSorting ||
      currentSorting.value === preloadedSortQueryParamsState[TYPE_QUALITY_ISSUES][SORTING_PARAMS.SORT]
        ? i18n.t('sort.sort')
        : currentSorting.labelDisplayText;

    this.state = {
      labelDisplayText,
      sortOptions
    };
  }

  componentWillReceiveProps(nextProps) {
    const newState = {};

    if (this.props.queryParams[SORTING_PARAMS.SORT] !== nextProps.queryParams[SORTING_PARAMS.SORT]) {
      const sortOptions = this.state.sortOptions;
      const currentSorting = sortOptions.find(option => option.value === nextProps.queryParams[SORTING_PARAMS.SORT]);
      newState.labelDisplayText = currentSorting ? currentSorting.labelDisplayText : i18n.t('sort.sort');
    }

    this.setState(newState);
  }

  handleSortChange(event) {
    const {setQueryParamsAction} = this.props;
    const {labelDisplayText} = event;
    this.setState({labelDisplayText});
    setQueryParamsAction({[SORTING_PARAMS.SORT]: event.value, [PAGE_PARAMS.OFFSET]: 0});
  }
  renderDropdown() {
    const {disabled, queryParams, displaySortDropdown} = this.props;

    return (
      <SelectBoxAdapter
        selectedOptions={this.state.sortOptions.find(option => option.value === queryParams[SORTING_PARAMS.SORT])}
        valueRenderer={() => ''}
        placeholder=""
        searchPlaceholder=""
        options={this.state.sortOptions}
        disabled={disabled}
        onChange={this.handleSortChange.bind(this)}
        onClose={() => displaySortDropdown(false)}
        onOpen={() => displaySortDropdown(true)}
        dropdownMaxWidth="none"
      />
    );
  }

  render() {
    const {onLabelClick, isOpen} = this.props;
    const {labelDisplayText} = this.state;
    const sortToggleButtonClass = cx('isui-filter-sort__show-sort', {
      'isui-filter-sort__show-sort--open': isOpen
    });
    return (
      <div className="isui-sort-wrapper">
        <span className={sortToggleButtonClass} onClick={onLabelClick}>
          {labelDisplayText}
        </span>
        <div className="Sort">{this.renderDropdown()}</div>
      </div>
    );
  }
}
